module.exports = __webpack_public_path__ + "05_bob_beige.2c85e275.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/05_bob_beige.png
// module id = xEX4
// module chunks = 0